import { StyleDictionary } from "pdfmake/interfaces";
import { InvoicePaymentsPdfColumn, InvoicePdfColumn, InvoiceSummaryPdfColumn } from "./types";

export const INVOICE_PDF_COLUMNS = [
	InvoicePdfColumn.POSITION,
	InvoicePdfColumn.NAME,
	InvoicePdfColumn.PKWIU,
	InvoicePdfColumn.UNIT,
	InvoicePdfColumn.QUANTITY,
	InvoicePdfColumn.UNIT_PRICE,
	InvoicePdfColumn.TOTAL_PRICE,
	InvoicePdfColumn.TAX,
];

export const INVOICE_SUMMARY_PDF_COLUMNS = [
	InvoiceSummaryPdfColumn.EMPTY,
	InvoiceSummaryPdfColumn.TAX,
	InvoiceSummaryPdfColumn.TOTAL_PRICE_NET,
	InvoiceSummaryPdfColumn.TAX_PRICE,
	InvoiceSummaryPdfColumn.TOTAL_PRICE_GROSS,
];

export const INVOICE_PAYMENTS_PDF_COLUMNS = [
	InvoicePaymentsPdfColumn.PAID,
	InvoicePaymentsPdfColumn.PAYMENT_METHOD,
	InvoicePaymentsPdfColumn.DATE,
	InvoicePaymentsPdfColumn.PRICE,
];

export const INVOICE_PDF_TABLE_STYLES: StyleDictionary = {
	bold: {
		bold: true,
	},
	header: {
		fontSize: 18,
		bold: true,
		alignment: "center",
	},
	table: {
		margin: [0, 20, 0, 0],
	},
	tableHeader: {
		bold: true,
		fontSize: 9,
		color: "#333a38",
	},
	tableCell: {
		bold: false,
		fontSize: 9,
		color: "#464e4c",
	},
	rightCorner: {
		fontSize: 11,
		alignment: "right",
	},
	label: {
		fontSize: 10,
		bold: true,
	},
	value: {
		fontSize: 10,
	},
	separator: {
		margin: [0, 0, 0, 10],
	},
};

export const INVOICE_CELL_BACKGROUND_COLOR = "#E2E2E2";
